/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M12 20L22 20M12 12L22 12M12 4H22"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M5 3V21M5 3L2 6M5 3L8 6M5 21L2 18M5 21L8 18"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				d="M12 20L22 20M12 12L22 12M12 4H22M5 3V21M5 3L2 6M5 3L8 6M5 21L2 18M5 21L8 18"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M12 20L22 20M12 12L22 12M12 4H22M5 3V21M5 3L2 6M5 3L8 6M5 21L2 18M5 21L8 18"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M12 20L22 20M12 12H16M20 12H22M12 4H22M5 21L2 18M5 21L8 18M5 21V14M5 3L2 6M5 3L8 6M5 3V10"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M12 20L22 20M12 12L22 12M12 4H22M5 3V21M5 3L2 6M5 3L8 6M5 21L2 18M5 21L8 18"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				d="M12 20L22 20M12 12L22 12M12 4H22M5 3V21M5 3L2 6M5 3L8 6M5 21L2 18M5 21L8 18"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
]);
